module.exports = __webpack_public_path__ + "static/atlas-hero-background-f1b4c2761e53925180726103085d121d.webp";